'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'bullhorn';
var width = 512;
var height = 512;
var aliases = [128226,128363];
var unicode = 'f0a1';
var svgPathData = 'M466.2 18.3c8.4 4 13.8 12.4 13.8 21.7l0 432c0 9.3-5.4 17.7-13.8 21.7s-18.3 2.7-25.5-3.2l-56.2-46.3c-41.2-34-91.7-54.5-144.5-59.2l0 79c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-84C40.8 365.8 0 315.6 0 256 0 185.3 57.3 128 128 128l89.4 0c61-.2 120-21.4 167.1-60.2l56.2-46.3c7.2-5.9 17.1-7.1 25.5-3.2zM240 336l0 .9c64 4.8 125.2 29.2 175 70.3l17 14 0-330.3-17 14c-49.8 41-111 65.5-175 70.3L240 336zm-48 48l-48 0 0 80 48 0 0-80zM128 176c-44.2 0-80 35.8-80 80s35.8 80 80 80l64 0 0-160-64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBullhorn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;